import { actionTypes } from '../actions/params'

// DEFAULT STATE
export const initParams = {
  wtRegion: 'US',
  division: '1',
  isoCode: 'en-US',
  isLeveraged: '-1',
  isFP: '0',
  isEU: false
}

// WRITES
const params = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_WTREGION:
      return Object.assign({}, state, {
        wtRegion: action.value
      })
    case actionTypes.SET_DIVISION:
      return Object.assign({}, state, {
        division: action.value
      })
    case actionTypes.SET_LANG:
      return Object.assign({}, state, {
        isoCode: action.value
      })
    case actionTypes.SET_LEVERAGE:
      return Object.assign({}, state, {
        isLeveraged: action.value
      })
    case actionTypes.SET_ISFP:
      return Object.assign({}, state, {
        isFP: action.value
      })
    case actionTypes.SET_ISEU:
      return Object.assign({}, state, {
        isEU: action.value
      })
    default:
      return state
  }
}

// READS
export const getwtRegion = state => state.params.wtRegion
export const getDivision = state => state.params.division
export const getLang = state => state.params.isoCode
export const getLeverage = state => state.params.isLeveraged
export const getFP = state => state.params.isFP
export const getIsEU = state => state.params.isEU
export const getinitialLoad = state => state.params.initialLoad
export default params



// WEBPACK FOOTER //
// ./src/reducers/params.js